import { useLiveQuery } from 'dexie-react-hooks';
import { rowsOf } from '@/data/items';
import { AREA_SECTIONS, countId } from '@/data/nights';
import { rt } from '@/data/runtime';
import type { AreaId, BusinessDate, CountEntry, Item, Movement, Night } from '@/domain/types';

export interface NightData {
  night: Night | undefined;
  items: Item[];
  itemById: Map<string, Item>;
  counts: Map<string, CountEntry>;
  moves: Movement[];
}

/** One night's records, live. Undefined while loading. */
export function useNightData(date: BusinessDate): NightData | undefined {
  return useLiveQuery(async () => {
    const db = rt().db;
    const [night, items, counts, moves] = await Promise.all([db.nights.get(date), db.items.toArray(), db.counts.where('date').equals(date).toArray(), db.moves.where('date').equals(date).toArray()]);
    return { night, items, itemById: new Map(items.map((i) => [i.id, i])), counts: new Map(counts.map((c) => [c.id, c])), moves: moves.filter((m) => !m.voided).sort((a, b) => (a.at < b.at ? 1 : -1)) };
  }, [date]);
}

export interface AreaProgress {
  total: number;
  counted: number;
  recounts: number;
}

export function areaProgress(data: NightData, date: BusinessDate, area: AreaId): AreaProgress {
  if (area === 'guns') {
    const n = data.night;
    return { total: 2, counted: (n?.gun1 != null ? 1 : 0) + (n?.gun2 != null ? 1 : 0), recounts: 0 };
  }
  let total = 0;
  let counted = 0;
  let recounts = 0;
  for (const s of AREA_SECTIONS[area])
    for (const it of rowsOf(data.items, s)) {
      total++;
      const c = data.counts.get(countId(date, s, it.id));
      if (c?.value != null) counted++;
      if (c?.recountRequestedAt) recounts++;
    }
  return { total, counted, recounts };
}
